import {
    Box,
    Button,
    ButtonGroup,
    IconButton,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CustomTabPanel } from ".";
import { useEffect, useState } from "react";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';


const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'location', headerName: 'Locacion', flex: 1 },
    { field: 'requireTest', headerName: 'Requerimiento', flex: 1 },
    { field: 'executedBy', headerName: 'Realizado por', flex: 1 },
    { field: 'planned', headerName: 'Planificado', flex: 1 },
    { field: 'visited', headerName: 'Visitado', flex: 1 },
    { field: 'executed', headerName: 'Ejecutado', flex: 1 },
];


export const RequirementComponent = ({ value, messageSummary, plannedActivities, requirementFilter, handleChangeRequirement }: { value: any, messageSummary:any, plannedActivities: any, requirementFilter: any, handleChangeRequirement: any }) => {

    const [requires, setRequires] = useState<any[]>([])

    const [options, setoptions] = useState<string[]>([])

    const [activeRequirements, setActiveRequirements] = useState<any>(undefined)

    const [activeExecutedFilter, setActiveExecutedFilter] = useState("all")

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {

        let data: any[] = []

        const options: string[] = [];

        let count = 0;

        plannedActivities?.forEach((act: any) => {

            const activityIdFilter = `${act.planningEndDate} - ${act.groupAssigned}`;

            options.push(activityIdFilter);

            act.requirements?.forEach((req: any) => {
                data.push({
                    id: count + 1,
                    location: req.location,
                    requireTest: req.requireTest,
                    executedBy: act.executedBy,
                    requiredDate: req.requiredDate,
                    executed: req.executed ? "Si" : "No",
                    visited: req.visited ? "Si" : "No",
                    planned: req.wasPlanned ? "Si" : "No",
                    optimizationActivity: req.optimizationActivity,
                    activityVariables: req.activityVariables,
                    activityIdFilter,
                    description: act.description
                })
                count++;
            })
        });


        if (activeExecutedFilter !== "all") {
            const filterData = data.filter((req: any) => req.executed === activeExecutedFilter)
            data = filterData;
        }

        if (requirementFilter !== "all") {
            const filterData = data.filter((req: any) => req.activityIdFilter === requirementFilter)
            data = filterData;
        }

        setoptions(options)

        setRequires(data)
    }, [plannedActivities, requirementFilter, activeExecutedFilter])


    const onClickRow = (row: any) => {
        
        if (row?.row?.activityVariables) {
            setActiveRequirements(row?.row)
        }
    }

    const onClickFilterExecuted = (flag: string) => {
        setActiveExecutedFilter(flag)
    }

    const openRequirementView = () => {
        console.log({ activeRequirements })
    }


    if (activeRequirements) {
        return (
            <CustomTabPanel value={value} index={2}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 3,
                    }}
                >
                    <IconButton
                        aria-label="delete"
                        onClick={() => setActiveRequirements(undefined)}
                        sx={{
                            backgroundColor: "#03365e",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#129ED3",
                            },
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <IconButton
                        aria-label="delete"
                        onClick={() => openRequirementView()}
                        sx={{
                            backgroundColor: "#03365e",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#129ED3",
                            },
                        }}
                    >
                        <OpenInNewIcon />
                    </IconButton>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6" color="initial">
                        Actividad Requerida : <strong>{activeRequirements?.requireTest}</strong> ({activeRequirements?.description})
                    </Typography>
                </Box>

                <Box sx={{ mt: 3, maxHeight: '50vh', overflowY: 'auto' }}>
                    {Object?.keys(activeRequirements?.activityVariables||[])?.map((key, index) => {
                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mb: 1,
                                    p: 1,
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                <Typography variant="body1" color="textPrimary" sx={{ pr: 2 }}>
                                    {key}
                                </Typography>
                                <Typography variant="body1" color="textSecondary" sx={{ pl: 2 }}>
                                    {activeRequirements?.activityVariables[key]}
                                </Typography>
                            </Box>
                        )
                    })}
                </Box>

            </CustomTabPanel>)
    }


    return (<CustomTabPanel value={value} index={2}>
        <Grid size={12}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 3,
                }}
            >
                <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="demo-simple-select-standard-label">Planning Activity</InputLabel>
                    <Select
                        value={requirementFilter}
                        onChange={handleChangeRequirement}
                        label="Planning Activity"
                    >
                        <MenuItem key="all" value="all">Todos</MenuItem>
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="body1" color="initial" sx={{ mr: 2 }} >
                        Ejecutado
                    </Typography>
                    <ButtonGroup variant="outlined" aria-label="Basic button group">
                        <Button variant={activeExecutedFilter === "all" ? "contained" : "outlined"} onClick={() => { onClickFilterExecuted("all") }}>Todo</Button>
                        <Button variant={activeExecutedFilter === "Si" ? "contained" : "outlined"} onClick={() => { onClickFilterExecuted("Si") }}>SI</Button>
                        <Button variant={activeExecutedFilter === "No" ? "contained" : "outlined"} onClick={() => { onClickFilterExecuted("No") }}>NO</Button>
                    </ButtonGroup>
                </Box>
            </Box>
            <Paper sx={{ height: '55vh', width: '100%' }}>
                <DataGrid
                    rows={requires}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{ border: 0 }}
                    onRowClick={(row) => onClickRow(row)}
                />
            </Paper>

        </Grid>
    </CustomTabPanel>)
}